import { combineReducers } from "redux";
import menu from "./menu";
import theme from "./theme";
import auth from "./auth";
import accounts from "store/reducers/accounts";
import vending from "store/reducers/vending";
import payments from "store/reducers/payments";
import machineConfig from "store/reducers/machineConfig";
import categorySlice from "store/reducers/product/categorySlice";
import subCategorySlice from "store/reducers/product/subCategorySlice";
import productSlice from "store/reducers/product/productSlice";
import productVariantSlice from "store/reducers/product/productVariantSlice";
import productOffersSlice from "store/reducers/product/productOffersSlice";
import productValidationSlice from "store/reducers/product/productValidationSlice";
import validationAllocationsSlice from "store/reducers/product/validationAllocationSlice";
import productGroup from "store/reducers/product/productGroupsSlice";
import paymentType from "store/reducers/payment/paymentSlice";
import refill from "store/reducers/refill/refillSlice";
import adsImage from "store/reducers/advertisement/adsImageSlice";
import adsVideo from "store/reducers/advertisement/adsVideoSlice";
import adsVideoAllocation from "store/reducers/advertisement/adsVideoAllocationSlice";
import location from "store/reducers/inventory/locationSlice";
import customers from "store/reducers/user_profiles/customerSlice";
import profiles from "store/reducers/user_profiles/profileSlice";
import smsProvider from "store/reducers/third_party/smsProviderSlice";
import validationAssignments from "store/reducers/product/validationAssignmentSlice";
import smsAssignments from "store/reducers/third_party/smsProviderAllocationSlice";
import notifications from "store/reducers/notifications/notificationsSlice";
import combinedNotifications from "store/reducers/notifications/combinedNotificationsSlice";
import statistics from "store/reducers/statistics/statisticsSlice";
import mainStock from "store/reducers/inventory/stock/mainStockSlice";
import distributorStock from "store/reducers/inventory/stock/distributorStockSlice";
import locationStock from "store/reducers/inventory/stock/locationStockSlice";
import adminStock from "store/reducers/inventory/stock/adminStockSlice";
import fillingPersonStock from "store/reducers/inventory/stock/fillingPersonStockSlice";
import fillingPersonReturn from "store/reducers/inventory/stock/fillingPeronReturnLogSlice";
import globalOffers from "store/reducers/global_offers/globalOffersSlice";
import productGst from "store/reducers/product/productGstSlice";
import invoicePdf from "store/reducers/invoice/invoiceSlice";
import invoiceConfig from "store/reducers/invoice/invoiceConfigSlice";
import order from "store/reducers/order/OrderSlice";
import productsForMachine from "store/reducers/refill/productsForMachineSlice";
import inventorySettings from "store/reducers/inventory/stock/inventorySettingsSlice";
import machineOps from "store/reducers/machine_ops/machineOpsSlice";

const reducers = combineReducers({
  menu,
  theme,
  auth,
  accounts,
  vending,
  payments,
  machineConfig,
  category: categorySlice,
  subCategory: subCategorySlice,
  product: productSlice,
  productVariant: productVariantSlice,
  productOffer: productOffersSlice,
  productValidation: productValidationSlice,
  validationAllocation: validationAllocationsSlice,
  productGroup,
  paymentType,
  refill,
  adsImage,
  adsVideo,
  adsVideoAllocation,
  location,
  customers,
  smsProvider,
  validationAssignments,
  smsAssignments,
  profiles,
  notifications,
  combinedNotifications,
  statistics,
  mainStock,
  distributorStock,
  locationStock,
  adminStock,
  fillingPersonStock,
  globalOffers,
  productGst,
  invoicePdf,
  invoiceConfig,
  order,
  productsForMachine,
  inventorySettings,
  fillingPersonReturn,
  machineOps
});

export default reducers;
